angular.module('permanentUnitModule').component('permanentUnitListing', {
    templateUrl: 'permanentUnitListing/permanentUnitListing.html',
    bindings: {
        rpc: '@',
        mobileMode: '@'
    },
    controller: ['PubSub', '$http', '$timeout', '$sce', '$compile', 'StateService', 'gVariables', 'crResourcesService', 'ImageService',
        function (PubSub, $http, $timeout, $sce, $compile, StateService, gVariables, crResourcesService, ImageService) {
            var ctrl = this;
            
            ctrl.$onInit = function() {
                ctrl.loadingData = true;
                ctrl.listing = null;
                ctrl.unitType = null;
                ctrl.prevAskingPrice = null;
                ctrl.showReadMore = false;
                ctrl.currentSlideIndex = 0;

                // Use mobile-specific placeholder images when in mobile mode, fall back to desktop images
                if (ctrl.mobileMode === 'true') {
                    if (window.NotFoundImageDsIdsForMobile && window.NotFoundImageDsIdsForMobile.length) {
                        let dsIdIndex = Math.floor(Math.random() * window.NotFoundImageDsIdsForMobile.length);
                        let dsId = window.NotFoundImageDsIdsForMobile[dsIdIndex];
                        let notFoundImageUrl = window.thumbor_server_cdn;
                        notFoundImageUrl += `/assets/fit-in/443x0/${dsId}`;
                        ctrl.notFoundImageUrl = notFoundImageUrl;
                    } else if (window.NotFoundImageDsIds && window.NotFoundImageDsIds.length) {
                        // Fallback to desktop images for mobile
                        let dsIdIndex = Math.floor(Math.random() * window.NotFoundImageDsIds.length);
                        let dsId = window.NotFoundImageDsIds[dsIdIndex];
                        let notFoundImageUrl = window.thumbor_server_cdn;
                        notFoundImageUrl += `/assets/fit-in/443x0/${dsId}`;
                        ctrl.notFoundImageUrl = notFoundImageUrl;
                    }
                } else {
                    // Desktop mode - use existing logic
                    if (window.NotFoundImageDsIds && window.NotFoundImageDsIds.length) {
                        let dsIdIndex = Math.floor(Math.random() * window.NotFoundImageDsIds.length);
                        let dsId = window.NotFoundImageDsIds[dsIdIndex];
                        let notFoundImageUrl = window.thumbor_server_cdn;
                        notFoundImageUrl += `/assets/fit-in/525x322/${dsId}`;
                        ctrl.notFoundImageUrl = notFoundImageUrl;
                    }
                }

                ctrl.loadData();
            };

            ctrl.loadData = function () {
                if (!ctrl.rpc) return;

                ctrl.loadingData = true;
                ctrl.showReadMore = false;

                $http({
                    method: 'GET',
                    url: ctrl.rpc,
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                }).then(function successCallback(response) {
                    ctrl.listing = response.data.listing || null;
                    ctrl.unitType = response.data.type || null;
                    ctrl.section = response.data.section || [];

                    if (ctrl.listing) {
                        ctrl.listing.listingSlides = [];
                        if (ctrl.listing.thumbor_images && ctrl.listing.thumbor_images.length > 0) {
                            ctrl.listing.thumbor_images.forEach(function (image) {
                                let processedImage = ImageService.getSmartImage(550, 357, image);
                                ctrl.listing.listingSlides.push(processedImage);
                            });
                        }
                        ctrl.listing.listingFloorplans = [];
                        if (ctrl.listing.thumbor_floorplans && ctrl.listing.thumbor_floorplans.length > 0) {
                            ctrl.listing.thumbor_floorplans.forEach(function (image) {
                                let processedImage = ImageService.getSmartImage(550, 357, image);
                                ctrl.listing.listingFloorplans.push(processedImage);
                            });
                        }

                        if (response.data.type == 'sold') {
                            ctrl.prevAskingPrice = ctrl.section.history.filter(item => item.eventType == 'price_changed' && item.price).shift();
                            if (!ctrl.prevAskingPrice) {
                                ctrl.prevAskingPrice = ctrl.section.history.filter(item => item.eventType == 'listed' && item.price).shift();
                            }
                            if (ctrl.prevAskingPrice) {
                                ctrl.prevAskingPrice = ctrl.prevAskingPrice.price;
                            }
                        }

                        $timeout(() => {
                            ctrl.checkDescriptionHeight();
                        });
                    }
                }).finally(function () {
                    ctrl.loadingData = false;
                });
            };

            ctrl.expandDescription = function () {
                ctrl.showReadMore = !ctrl.showReadMore;
            }

            ctrl.openPopup = (event, listing, type) => {
                event.stopPropagation();
                
                // On mobile, navigate directly to listing page instead of opening popup.
                // CITY-5489: also gate on the viewport — the permanent-unit page now
                // serves the neo (desktop) template to phones, where mobileMode isn't
                // set, so the width check is what catches it. Return either way so we
                // never fall through to the Blimp popup, which isn't mobile friendly.
                if (ctrl.mobileMode === 'true' || window.innerWidth < 1023) {
                    if (listing.url_listing) {
                        window.location.href = listing.url_listing;
                    }
                    return;
                }
                
                // Check if BlimpExtV2 is available (may not be loaded on mobile)
                if (typeof BlimpExtV2 === 'undefined') {
                    // Fallback to direct navigation if Blimp is not available
                    if (listing.url_listing) {
                        window.location.href = listing.url_listing;
                    }
                    return;
                }
                
                // Desktop behavior - open popup
                if (!listing.blimp) {
                    let galleryLink = event.target.closest('.gallery_link');
                    let others_behind = true;
                    listing.blimp = new BlimpExtV2(galleryLink, {
                        cache: true,
                        draggable: true,
                        show_veil: true,
                        fullscreen: true,
                        display: type,
                        put_others_behind: others_behind,
                        onFetch: function () {
                            if (listing.markerLabel) {
                                listing.markerLabel.marker.clicked = true;
                            }

                            _gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
                        },
                        onPostRpc: function () {
                            this.add_extra(true);
                            Core.compile_html(this._element);
                        },
                    });
                    listing.blimp.handle_link_click();
                } else {
                    listing.blimp.handle_link_click();
                    listing.blimp.show_widget(type);
                    if (type == 'gallery' && listing.blimp && listing.blimp.pagePhotogallery && listing.blimp.pagePhotogallery.pg && listing.blimp.pagePhotogallery.pg.current_index) {
                        listing.blimp.pagePhotogallery.pg.scrollMainToPosition(listing.blimp.pagePhotogallery.pg.current_index);
                    }
                }
            };

            ctrl.checkDescriptionHeight = function() {
                let descriptionElement = document.querySelector('.listing-data .listing-description');
                if (descriptionElement) {
                    if (descriptionElement.scrollHeight <= 120) {
                        ctrl.showReadMore = false;
                    } else {
                        ctrl.showReadMore = true;
                    }
                }
            }

            ctrl.nextSlide = function () {
                if (!ctrl.listing || !ctrl.listing.listingSlides) return;
                ctrl.currentSlideIndex = (ctrl.currentSlideIndex + 1) % ctrl.listing.listingSlides.length;
            };

            ctrl.prevSlide = function () {
                if (!ctrl.listing || !ctrl.listing.listingSlides) return;
                ctrl.currentSlideIndex = (ctrl.currentSlideIndex - 1 + ctrl.listing.listingSlides.length) % ctrl.listing.listingSlides.length;
            };
        }
    ]
});

angular.module('permanentUnitModule').filter('nl2br', ['$sce', function ($sce) {
    return function (text) {
        if (!text) return '';
        return $sce.trustAsHtml(String(text).replace(/\n/g, '<br>'));
    };
}]);